
import './style/index.scss'
import Vue from 'vue'
import App from './App.vue'
import './utils/flexible.js'
import * as Sentry from '@dida-sentry/h5'
import { BrowserTracing } from '@sentry/tracing'
import packageInfo from '../package.json'
import { BsGetEnv, VnToast, VnLoginToast, BsSetWebp } from 'dida-web-common'
import zenus from './zeusComponent/index'
import _shareInit from './utils/share.js'
import track from './utils/track.js'
import DATA from './config.js'
import routerset from './utils/routerset.js'

const name = DATA.shareData.prodectName
let router = location.pathname.replace('/' + name + '/', '').split('/')
router = router.length === 1 && router[0] ? router.pop() : 'default'
if (/refresh$/.test(router)) {
    router = 'default'
    history.go(-1)
}
if (history.scrollRestoration) {
    history.scrollRestoration = 'manual'
}
Vue.use(VnToast)
zenus(Vue)

const _mainThread = async() => {
    const isSuWebp = await BsSetWebp.init(Vue)
    Vue.config.productionTip = false
    Vue.prototype.$track = await track(DATA?.options.basic.itemTypes || name)
    Vue.prototype.DATA = DATA
    Vue.prototype.$bus = new Vue({ 'data': () => ({ 'store': {}}) })
    const _v = new Vue({
        'data': () => ({
            didaUser: {},
            'componentsLoaded': false,
            'componentsMap': {},
            isSuWebp,
            'emitList': {},
            'closeLoading': false,
            pageRouter: {},
            currentRouter: router,
            productName: name
        }),
        'render': (h) => h(App),
        'methods': {
            updateComponentsListener(compList = []) {
                compList.forEach((comp) => {
                    Object.defineProperty(window, comp, {
                        get() {
                            return _v.componentsMap[comp]
                        },
                        'set': (v) => {
                            Vue.set(_v.componentsMap, comp, v)
                        },
                        'enumerable': true,
                        'configurable': true
                    })
                })
            },
            getCompNameCollection(data = []) {
                const compSet = new Set()
                const dfs = (cps) => {
                    cps.forEach((cp) => {
                        if (cp.type === 'group') {
                            dfs(cp.children)
                        } else if (!window[cp.type]) {
                            compSet.add(cp.type)
                        }
                    })
                }
                data.forEach(({ components = [] }) => {
                    dfs(components)
                })

                return [...compSet]
            }
        }
    }).$mount('#appRender')

    /* **** 组件加载 **** */
    // eslint-disable-next-line no-unexpected-multiline
    Vue.prototype.$Login = function() {
        _v.$track.addStat('login_click')
        VnLoginToast.vnLogin({
            success: (user) => {
                _v.$track.addStat('login_success')
                _v.$bus.$emit('logined', { ...user })
                _v.$set(_v.$data, 'didaUser', user)
            }
        })
    };
    // window.addEventListener('hashchange', async() => {
    //     const user = await BsGetCid()
    //     if (wxDt && user.cid && user.access_token) {
    //         wxDt = false
    //         _v.$bus.$emit('logined', { ...user })
    //         _v.$set(_v.$data, 'didaUser', user)
    //     }
    // }, false);
    (async() => {
        const _DATA = [...(DATA?.pageData || []), ...(DATA?.fixedData || [])]
        if (DATA) {
            _v.updateComponentsListener(_v.getCompNameCollection(_DATA))
        }
        _v.$set(_v.$data, 'componentsLoaded', true)
        routerset(_v, function() {
            DATA && DATA.shareData && _shareInit(DATA?.shareData, DATA?.options.basic.itemTypes)
        })
    })()
    /* **** End **** */
}
const autoLogin = DATA?.options?.basic?.autoLogin
if (autoLogin === false) {
    VnLoginToast.vnLogin({
        success: () => {
            _mainThread()
        }
    })
} else {
    _mainThread()
}

(() => {
    // await _loadInit()
    DATA && DATA.shareData && _shareInit(DATA?.shareData, DATA?.options.basic.itemTypes)
    if (DATA.options && DATA.options.basic.sentry) {
        Sentry.init({
          Vue,
          release: packageInfo.name + '@' + packageInfo.version,
          environment: BsGetEnv.isEnvOnline ? 'online' : (BsGetEnv.isEnvECS ? 'simu' : 'test'),
          dsn: DATA.options.basic.sentry,
          integrations: [
            new BrowserTracing({
            //   routingInstrumentation: Sentry.vueRouterInstrumentation(router),
              tracingOrigins: ['localhost', 'capis.didapinche.com', 'capis-ecs.didapinche.com', 'capis-test.didapinche.com']
            })
          ],
          tracesSampleRate: 1.0
        })
      }
})()

/* **** 页面关闭阻塞，保证埋点执行 **** */
// window.onunload = () => {
//     const now = new Date()
//     // eslint-disable-next-line no-empty
//     while (new Date() - now < 100) { }
// }
/* **** End **** */
